import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Funções de máscara
export function maskCPF(value: string): string {
  const cpf = value.replace(/\D/g, '')
  if (cpf.length <= 3) return cpf
  if (cpf.length <= 6) return `${cpf.slice(0, 3)}.${cpf.slice(3)}`
  if (cpf.length <= 9)
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`
  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(
    9,
    11
  )}`
}

export function maskTelefone(value: string): string {
  const telefone = value.replace(/\D/g, '')
  if (telefone.length <= 2)
    return telefone.length > 0 ? `(${telefone}` : telefone
  if (telefone.length <= 7)
    return `(${telefone.slice(0, 2)}) ${telefone.slice(2)}`
  if (telefone.length <= 10)
    return `(${telefone.slice(0, 2)}) ${telefone.slice(2, 6)}-${telefone.slice(
      6
    )}`
  return `(${telefone.slice(0, 2)}) ${telefone.slice(2, 7)}-${telefone.slice(
    7,
    11
  )}`
}

export function unmaskCPF(value: string): string {
  return value.replace(/\D/g, '')
}

export function unmaskTelefone(value: string): string {
  return value.replace(/\D/g, '')
}

export function maskCEP(value: string): string {
  const cep = value.replace(/\D/g, '')
  if (cep.length <= 5) return cep
  return `${cep.slice(0, 5)}-${cep.slice(5, 8)}`
}

export function unmaskCEP(value: string): string {
  return value.replace(/\D/g, '')
}

export function maskCNPJ(value: string): string {
  const cnpj = value.replace(/\D/g, '')
  if (cnpj.length <= 2) return cnpj
  if (cnpj.length <= 5) return `${cnpj.slice(0, 2)}.${cnpj.slice(2)}`
  if (cnpj.length <= 8)
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5)}`
  if (cnpj.length <= 12)
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8)}`
  return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`
}

export function unmaskCNPJ(value: string): string {
  return value.replace(/\D/g, '')
}

// Funções para formatação de data (dd/MM/yyyy)
export function maskData(value: string): string {
  // Remove tudo que não é número
  const data = value.replace(/\D/g, '')
  
  // Aplica a máscara dd/MM/yyyy
  if (data.length <= 2) return data
  if (data.length <= 4) return `${data.slice(0, 2)}/${data.slice(2)}`
  return `${data.slice(0, 2)}/${data.slice(2, 4)}/${data.slice(4, 8)}`
}

export function unmaskData(value: string): string {
  return value.replace(/\D/g, '')
}

// Converte dd/MM/yyyy para YYYY-MM-DD (formato ISO para o backend)
export function convertDataToISO(data: string): string | undefined {
  if (!data || data.trim() === '') return undefined
  
  // Verifica se está no formato dd/MM/yyyy
  const dateRegexBR = /^\d{2}\/\d{2}\/\d{4}$/
  if (!dateRegexBR.test(data)) {
    // Se já está no formato YYYY-MM-DD, retorna como está
    const dateRegexISO = /^\d{4}-\d{2}-\d{2}$/
    if (dateRegexISO.test(data)) {
      return data
    }
    return undefined
  }
  
  const partes = data.split('/')
  const dia = parseInt(partes[0])
  const mes = parseInt(partes[1])
  const ano = parseInt(partes[2])
  
  // Valida a data antes de converter
  if (ano < 1 || ano > 9999) return undefined
  if (mes < 1 || mes > 12) return undefined
  if (dia < 1 || dia > 31) return undefined
  
  // Cria a data para validar se é uma data válida
  const date = new Date(ano, mes - 1, dia)
  if (
    date.getFullYear() !== ano ||
    date.getMonth() !== mes - 1 ||
    date.getDate() !== dia
  ) {
    return undefined
  }
  
  // Retorna no formato YYYY-MM-DD
  return `${ano.toString().padStart(4, '0')}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`
}

// Converte YYYY-MM-DD para dd/MM/yyyy (formato brasileiro)
export function convertISOToData(isoDate: string): string {
  if (!isoDate || isoDate.trim() === '') return ''
  
  // Verifica se já está no formato YYYY-MM-DD
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  if (!dateRegex.test(isoDate)) return isoDate
  
  const partes = isoDate.split('-')
  const ano = partes[0]
  const mes = partes[1]
  const dia = partes[2]
  
  // Retorna no formato dd/MM/yyyy
  return `${dia}/${mes}/${ano}`
}